import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { InputContainer } from "@sellar-io/components";

export const TableInputContainer = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <InputContainer
      className={twMerge(
        "py-2 shadow-[0_1px_2px_0_rgba(0,0,0,0.1)]",
        className,
      )}
    >
      {children}
    </InputContainer>
  );
};
